import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import { store } from '@/common/root';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const taskMap: TaskMap = {
  [TaskName.ABGW_STANDALONE_DEPLOYMENT]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Backup storage created'),
      message: i18n.t('Backup storage successfully created')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Creating backup storage...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error creating backup storage'),
      message: error
    })
  },
  [TaskName.ABGW_NODE_ASSIGN]: {
    [TaskState.SUCCESS]: ({ payload }) => {
      const node = store.getters['locations/getNodeById'](payload.nodes[0]);

      return {
        title: i18n.tc('Node added|Nodes added', payload.nodes.length),
        message: i18n.tc(
          'Node "{name}" successfully added|{count} nodes successfully added',
          payload.nodes.length,
          { name: node.name, count: payload.nodes.length }
        )
      };
    },
    [TaskState.RUNNING]: ({ payload }) => {
      const node = store.getters['locations/getNodeById'](payload.nodes[0]);

      return {
        message: i18n.tc(
          'Adding node "{name}" to backup storage...|Adding {count} nodes to backup storage...',
          payload.nodes.length,
          { name: node.name, count: payload.nodes.length }
        )
      };
    },
    [TaskState.FAILED]: ({ error, payload }) => ({
      title: i18n.tc('Error adding node to backup storage|Error adding nodes to backup storage', payload.nodes.length),
      message: error
    })
  },
};

export default taskMap;
